import script from "./StoreCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./StoreCard.vue?vue&type=script&setup=true&lang=ts"

import "./StoreCard.vue?vue&type=style&index=0&id=6185e20a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kevin\\Desktop\\Vue_Shop-Sushiro--main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6185e20a"]])

export default __exports__